import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { LzCookieService } from "../../../../services/lz-cookie/lz-cookie";
import { LzLanguageService } from '../../../../services/lz-language/lz-language.service';
import { AfterContentInit, Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { InvisibleReCaptchaComponent } from 'ngx-captcha';
import { Subscription, Observable, interval } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import { CustomRequestService } from "../../../../services/custom-request/custom-request.service";
import { LzProductConfig } from "../../../../services/product-config/poduct-config";

declare var $: any;
declare var grecaptcha: any;

@Component({
  selector: 'app-lz-reg-new',
  template: `<div class="registration">


  <div class="slider-container" *ngIf="isShowSlider">
    <div class="slider-title">
      <img src="{{product.logoSmall}}" alt="">
      <div class="product-name">{{product.title}}</div>
    </div>
    <div *ngIf="isShowSlider" class="close-mobile" (click)="cancel()"><i class="fa fa-remove"></i></div>
    <div class="slider-desc">
      <p>{{product.description}}</p>
    </div>
    <div class="line" [ngStyle]="{'background-color':product.backgroundColor}"></div>
    <div class="desc" *ngIf="product.presentation.video">
      <p>{{product.presentation.descriptionBottom}}</p>
    </div>
    <div *ngFor="let slide of product.presentation.slides">
      <div class="desc" *ngIf="!product.presentation.video && slide == currentActiveImg">
        <p>{{slide.description}}</p>
      </div>
    </div>
    <div class="mobile-wrapper" [ngClass]="{'video': product.presentation.video}">
      <div class="laptop"><img src="/dist/ng2/src/assets/pl-header-assets/img/laptop.png" alt=""></div>
      <div class="mobile-control left" *ngIf="!product.presentation.video"><i class="fa fa-chevron-left" (click)="setActivePrev()"></i></div>
      <div class="slider-wrapper" *ngIf="!product.presentation.video">
        <div class="slider-item" id="swipe" *ngFor="let img of product.presentation.slides" [ngClass]="{'active': img == currentActiveImg}">
          <img src="{{img.src}}">
        </div>
      </div>
      <div class="video-container" *ngIf="product.presentation.video">
        <iframe width="430" height="242" [src]="videoUrl">
        </iframe>
      </div>
      <div class="mobile-control right" *ngIf="!product.presentation.video"><i class="fa fa-chevron-right" (click)="setActiveNext()"></i></div>
    </div>
  </div>
  <div class="right-block">
    <div class="reg-footer" *ngIf="isShowSlider">
      <div class="footer-title">
        <p>{{'user.signinup.unitedProfile' | translate}}</p>
      </div>
      <div class="footer-list">
        <ul>
          <li *ngFor="let item of products">
            <a target="_blank" rel="noopener noreferrer" href="{{item.enterLink}}">{{item.title}}</a>
          </li>
          <li>
            <a target="_blank" rel="noopener noreferrer" href="http://platforma.ligazakon.net">{{'user.signinup.others'
              | translate}}</a>
          </li>

        </ul>
      </div>
    </div>
    <div class="registration-form">
      <div *ngIf="isShowSlider === false" class="close-mobile" (click)="cancel()"><i class="fa fa-remove"></i></div>
      <div class="lz-logo"><img src="/dist/ng2/src/assets/pl-header-assets/img/lz-logo-cut.png" alt=""></div>
      <div class="lz-logo-mobile"><img src="/dist/ng2/src/assets/pl-header-assets/img/lz-logo.png" alt=""></div>
      <div class="mobile-title">
        <h1>{{'user.signinup.regTitle' | translate}}</h1>
        <div class="signIn-mobile"><span (click)="showAuthModal()" id="{{id}}-main-click-to_login-link-popup_register-1">{{'user.signinup.signInNew'
            | translate}}</span></div>
      </div>
      <div class="close" (click)="cancel()"><i class="fa fa-remove"></i></div>
      <form name="regForm" [formGroup]="regForm" novalidate>
        <div class="form-group">
          <input type="text" class="input-field" name="firstname" id="{{id}}-main-click-firstname_field-input-popup_register-1"
            [(ngModel)]="data.name" formControlName="firstname" placeholder="{{'user.signinup.firstname' | translate}}"
            [maxlength]="256" [ngClass]="{'submitted' : this.submitted}" required>
          <div class="error-field" *ngIf="(regForm.get('firstname').invalid && regForm.get('firstname').touched)">
          </div>
        </div>
        <div class="form-group">
          <input type="text" class="input-field" name="lastname" [(ngModel)]="data.lastname" formControlName="lastname"
            id="{{id}}-main-click-lastname_field-input-popup_register-1" placeholder="{{'user.signinup.lastname' | translate}}"
            [ngClass]="{'submitted' : this.submitted}" [maxlength]="256" required>
          <div class="error-field" *ngIf="regForm.get('lastname').invalid && regForm.get('lastname').touched">
          </div>
        </div>
        <div class="form-group">
          <input type="text" class="input-field" name="email" id="{{id}}-main-click-email_field-input-popup_register-1"
            [(ngModel)]="data.email" formControlName="email" placeholder="{{'user.signinup.email' | translate}}"
            [maxlength]="256" [ngClass]="{'submitted' : this.submitted}" required>
          <div class="error-field" *ngIf="regForm.get('email').errors && (regForm.get('email').invalid && regForm.get('email').touched) || showEmailErrorMessage">
            <span *ngIf="!serverMessage  && regForm.get('email').errors && regForm.get('email')['errors']['pattern']">{{'user.signinup.emailRegPattern'
              | translate}}</span>
            <span *ngIf="showEmailErrorMessage">{{serverMessage.email}}</span>
          </div>
          <div class="qmark">
            <div class="hint">
              <p>{{'user.signinup.tip' | translate}}</p>
            </div><i class="fa fa-question-circle-o"></i>
          </div>
        </div>
        <div class="form-group">
          <input type="text" class="input-field" name="phone" id="{{id}}-main-click-phone_field-input-popup_register-1"
            [(ngModel)]="data.phone" [textMask]="{mask: mask, showMask: false}" formControlName="phone" placeholder="{{'user.signinup.phone' | translate}}"
            [ngClass]="{'submitted' : this.submitted}" required>
          <div class="error-field" *ngIf="regForm.get('phone').errors && (regForm.get('phone').invalid && regForm.get('phone').touched) || showPhoneErrorMessage">
            <!--<span *ngIf="!serverError && regForm.get('phone').errors && regForm.get('phone')['errors']['pattern']">{{'lzPurchase.phonePattern' | translate}}</span>-->
            <span *ngIf="showPhoneErrorMessage">{{serverMessage.phone}}</span>
          </div>
        </div>
        <div class="form-group">

          <input type="text" class="input-field" name="company" id="{{id}}-main-click-companyname_field-input-popup_register-1"
            [(ngModel)]="data.company" formControlName="company" placeholder="{{'user.signinup.companyName' | translate}}"
            [ngClass]="{'submitted' : this.submitted}" [maxlength]="256" required>
          <div class="error-field" *ngIf="(regForm.get('company').invalid && regForm.get('company').touched)">
          </div>
        </div>

        <fieldset onclick="" class="check">
          <label onclick="" class="container">{{'user.signinup.agree' | translate}}<a target="_blank" rel="noopener noreferrer"
              id="{{id}}-main-click-rules-link-popup_register-1" href="http://support1.ligazakon.ua/politika-konfidencijnosti-ta-obrobki-personalnix-danix">
              {{'user.signinup.personalData' | translate}}</a>{{'user.signinup.and' | translate}}<a target="_blank" rel="noopener noreferrer"
              id="{{id}}-main-click-licen_agree-link-popup_register-1" href="https://ligazakon.net/license">{{'user.signinup.license'
              | translate}}</a>

            <div class="error-field-confirmData" *ngIf="(regForm.get('confirmDataSaving').invalid && regForm.get('confirmDataSaving').touched) ||
                        (regForm.get('confirmDataSaving').invalid && regForm.get('confirmDataSaving').dirty) ||
                        (regForm.get('confirmDataSaving').invalid && this.submitted)">
              <span>{{'lzPurchase.regConfirmDataError' | translate}}</span>
              <div class="pointer"></div>
            </div>
            <input type="checkbox" class="form-control confirmDataSavingCheckbox" formControlName="confirmDataSaving"
              id="{{id}}-main-click-i_agree-chkbox-popup_register-1">

            <span class="checkmark"></span>
          </label>

        </fieldset>
        <button (click)="execute()" id="{{id}}-main-click-register_email-button-popup_register-1" [ngClass]="{'loading': isDisabled}"
          [disabled]="isDisabled">
          <p *ngIf="!isDisabled">{{'user.signinup.reg' | translate}}</p>
          <lz-preloader *ngIf="isDisabled"></lz-preloader>
        </button>
        <div class="signIn"><span (click)="showAuthModal()">{{'user.signinup.signInNew' | translate}}</span>
        </div>
      </form>
      <section class="social-network">
        <div class="or"><span>{{'user.signinup.orBlock' | translate}}</span></div>
        <div class="social-network_icons">
          <div class="social-network_btn" id="{{id}}-main-click-register_fb-button-popup_register-1" (click)="getToken('/lzwpservice/authorize/authSN/facebook')">
            <i class="fa fa-facebook"></i>
          </div>
          <div class="social-network_btn" id="{{id}}-main-click-register_google-button-popup_register-1" (click)="getToken('/lzwpservice/authorize/authSN/google')">
            <i class="fa fa-google-plus"></i>
          </div>
          <!--<div class="social-network_btn" id="{{id}}-main-click-register_linkedin-button-popup_register-1" (click)="getToken('/lzwpservice/authorize/authSN/linkedin')">-->
            <!--<i class="fa fa-linkedin"></i>-->
          <!--</div>-->
        </div>
      </section>
    </div>
    <div class="reg-footer-mobile">
      <div class="footer-title">
        <p>{{'user.signinup.unitedProfile' | translate}}</p>
      </div>
      <div class="footer-list">
        <ul>
          <li *ngFor="let item of products">
            <a target="_blank" rel="noopener noreferrer" href="{{item.enterLink}}">{{item.title}}</a>
          </li>
          <li>
            <a target="_blank" rel="noopener noreferrer" href="http://platforma.ligazakon.net">{{'user.signinup.others'
              | translate}}</a>
          </li>

        </ul>
      </div>
    </div>
  </div>
  <form [formGroup]="cFormGroup">
    <ngx-invisible-recaptcha hl="uk" #captchaRef (success)="reg($event)" siteKey="6LcfMkgUAAAAAOmzWe6krfV-cgR3MczaQVrqxUVR"
      formControlName="recaptcha"></ngx-invisible-recaptcha>
  </form>
</div>
`,
  styles: [`@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Thin.eot);src:local('Geometria Thin'),local('Geometria-Thin'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Thin.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Thin.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Thin.ttf) format('truetype');font-weight:100;font-style:normal}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-MediumItalic.eot);src:local('Geometria MediumItalic'),local('Geometria-MediumItalic'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-MediumItalic.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-MediumItalic.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-MediumItalic.ttf) format('truetype');font-weight:500;font-style:italic}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Italic.eot);src:local('Geometria Italic'),local('Geometria-Italic'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Italic.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Italic.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Italic.ttf) format('truetype');font-weight:400;font-style:italic}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Heavy.eot);src:local('Geometria Heavy'),local('Geometria-Heavy'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Heavy.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Heavy.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Heavy.ttf) format('truetype');font-weight:900;font-style:normal}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraBoldItalic.eot);src:local('Geometria ExtraBoldItalic'),local('Geometria-ExtraBoldItalic'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraBoldItalic.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraBoldItalic.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraBoldItalic.ttf) format('truetype');font-weight:800;font-style:italic}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Medium.eot);src:local('Geometria Medium'),local('Geometria-Medium'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Medium.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Medium.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Medium.ttf) format('truetype');font-weight:500;font-style:normal}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-BoldItalic.eot);src:local('Geometria BoldItalic'),local('Geometria-BoldItalic'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-BoldItalic.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-BoldItalic.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-BoldItalic.ttf) format('truetype');font-weight:700;font-style:italic}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-LightItalic.eot);src:local('Geometria LightItalic'),local('Geometria-LightItalic'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-LightItalic.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-LightItalic.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-LightItalic.ttf) format('truetype');font-weight:300;font-style:italic}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-HeavyItalic.eot);src:local('Geometria HeavyItalic'),local('Geometria-HeavyItalic'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-HeavyItalic.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-HeavyItalic.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-HeavyItalic.ttf) format('truetype');font-weight:900;font-style:italic}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria.eot);src:local('Geometria'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria.ttf) format('truetype');font-weight:400;font-style:normal}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Bold.eot);src:local('Geometria Bold'),local('Geometria-Bold'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Bold.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Bold.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Bold.ttf) format('truetype');font-weight:700;font-style:normal}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraBold.eot);src:local('Geometria ExtraBold'),local('Geometria-ExtraBold'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraBold.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraBold.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraBold.ttf) format('truetype');font-weight:800;font-style:normal}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ThinItalic.eot);src:local('Geometria ThinItalic'),local('Geometria-ThinItalic'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ThinItalic.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ThinItalic.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ThinItalic.ttf) format('truetype');font-weight:100;font-style:italic}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraLightItalic.eot);src:local('Geometria ExtraLightItalic'),local('Geometria-ExtraLightItalic'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraLightItalic.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraLightItalic.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraLightItalic.ttf) format('truetype');font-weight:200;font-style:italic}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Light.eot);src:local('Geometria Light'),local('Geometria-Light'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Light.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Light.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-Light.ttf) format('truetype');font-weight:300;font-style:normal}@font-face{font-family:Geometria;src:url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraLight.eot);src:local('Geometria ExtraLight'),local('Geometria-ExtraLight'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraLight.eot?#iefix) format('embedded-opentype'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraLight.woff) format('woff'),url(/dist/ng2/src/assets/pl-header-assets/fonts/Geometria/Geometria-ExtraLight.ttf) format('truetype');font-weight:200;font-style:normal}.lz-pl-container{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container{width:732px;padding:0}}@media (min-width:1002px){.lz-pl-container{width:976px}}@media (min-width:1490px){.lz-pl-container{width:1440px}}.lz-pl-container-new{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container-new{width:732px;padding:0}}@media (min-width:1200px){.lz-pl-container-new{width:1200px}}@media (min-width:1490px){.lz-pl-container-new{width:1440px}}.modal-lg{width:900px}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}*{text-shadow:none!important;margin:0;padding:0}body,h1,h2,h3,h4,h5,h6,ol,p,ul{margin:0;padding:0;font-weight:400}ol,ul{list-style:none}img{max-width:100%;height:auto;vertical-align:middle}.h1,.h2,.h3,.h4,.h5,.h6,button,h1,h2,h3,h4,h5,h6,input,p,textarea{font-family:inherit;font-size:inherit;font-weight:inherit}input:focus,textarea:focus{outline:0}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{line-height:1.1}fieldset{border:none}::ng-deep .cdk-global-scrollblock{position:static!important;overflow:hidden}::ng-deep .cdk-global-scrollblock body{overflow:hidden}::ng-deep .cdk-overlay-backdrop{background:rgba(0,0,0,.588)}::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{margin:0;max-height:95vh;max-width:95vw;border-radius:0;padding:0;background:rgba(0,0,0,0);-webkit-box-shadow:none;box-shadow:none;opacity:1;overflow:visible;font-family:Geometria,sans-serif!important;font-weight:400}input:-webkit-autofill,input:-webkit-autofill:focus,input:-webkit-autofill:hover{border:0;-webkit-text-fill-color:#fff;-webkit-box-shadow:0 0 0 1000px transparent inset;box-shadow:0 0 0 1000px transparent inset;-webkit-transition:background-color 5000s ease-in-out;transition:background-color 5000s ease-in-out;background:-webkit-linear-gradient(top,rgba(255,255,255,0) 0,rgba(0,174,255,.04) 50%,rgba(255,255,255,0) 51%,rgba(0,174,255,.03) 100%)}.registration{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative}.registration .slider-container{width:580px;height:585px;background-color:#fff;position:absolute;top:-35px;left:-80px;padding:0 75px}@media (max-width:1199px){::ng-deep .cdk-overlay-container .myPane{max-width:640px!important}::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{overflow-x:hidden;max-width:640px}.registration{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.registration .slider-container{width:635px;height:auto;position:relative;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;top:0;left:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;padding:0 30px}}.registration .slider-container .slider-title{margin-top:30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.registration .slider-container .slider-title img{margin-right:10px}@media (max-width:1199px){.registration .slider-container .slider-title{width:321px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.registration .slider-container .slider-title .product-name{font-weight:700;font-size:34px;text-align:left;line-height:30px}.registration .slider-container .close-mobile{position:absolute;border:1px solid #c0c5e2;color:#c0c5e2;right:10px;top:10px;width:35px;padding:5px;text-align:center;cursor:pointer;display:none}@media (max-width:420px){.registration .slider-container .close-mobile{right:60px}}.registration .slider-container .slider-desc{margin-top:10px;font-size:14px}@media (max-width:1199px){.registration .slider-container .close-mobile{display:block}.registration .slider-container .slider-desc{margin-top:5px}}@media (max-width:758px){::ng-deep .cdk-overlay-container .myPane{max-width:450px!important}::ng-deep .cdk-overlay-container .myPane .mat-dialog-container{max-width:450px}.registration{width:450px}.registration .slider-container{width:450px;max-width:100%}.registration .slider-container .slider-title .product-name{font-size:25px}.registration .slider-container .slider-desc{margin-left:20px;margin-right:20px}}.registration .slider-container .line{margin-top:10px;width:50px;height:3px}@media (max-width:1199px){.registration .slider-container .line{margin-left:0;margin-top:5px}}.registration .slider-container .desc{margin-top:10px;font-size:18px;font-weight:700;width:430px;line-height:125%;height:70px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}@media (max-width:430px){.registration .slider-container .desc{width:300px}}@media (max-width:1199px){.registration .slider-container .desc{margin-left:0;margin-top:5px;height:auto;display:block}.registration .slider-container .mobile-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:5px 0 90px;font-size:21px;width:95%}}.registration .slider-container .mobile-wrapper.video{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.registration .slider-container .mobile-wrapper .laptop{position:absolute;left:25px;top:240px}@media (max-width:758px){.registration .slider-container .mobile-wrapper{margin:5px 0 20px;width:80%}.registration .slider-container .mobile-wrapper .laptop{display:none}}.registration .slider-container .slider-wrapper{margin-top:15px;height:261px;width:430px;display:block;overflow:hidden;position:absolute;bottom:66px}@media (max-width:1199px){.registration .slider-container .mobile-wrapper .laptop{bottom:25px;top:auto;width:585px;z-index:0;pointer-events:none}.registration .slider-container .mobile-wrapper .laptop img{width:100%}.registration .slider-container .slider-wrapper{width:465px;height:285px;top:25px;margin-left:0;margin-top:0;position:relative;bottom:0}.registration .slider-container .slider-wrapper img{width:465px;height:285px}}@media (max-width:758px){.registration .slider-container .slider-wrapper{width:320px;height:180px;top:auto}.registration .slider-container .slider-wrapper img{width:320px;height:180px}}.registration .slider-container .video-container{margin-top:15px}.registration .slider-container .mobile-control{display:block;color:#000;position:absolute;top:64%;cursor:pointer}.registration .slider-container .mobile-control.left{left:40px}.registration .slider-container .mobile-control.right{right:40px}@media (max-width:1199px){.registration .slider-container .video-container{margin-bottom:0;margin-left:0;margin-top:5px}.registration .slider-container .mobile-control{position:relative;top:20px;display:block;color:#d6d6d6}.registration .slider-container .mobile-control.left{left:auto}.registration .slider-container .mobile-control.right{right:auto}}@media (max-width:758px){.registration .slider-container .mobile-control{position:relative;top:0;display:block;color:#d6d6d6}.registration .slider-container .mobile-control.left{left:-20px}.registration .slider-container .mobile-control.right{right:-20px}}.registration .slider-container .controls{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;right:240px;bottom:40px}.registration .slider-container .controls .middle{width:65px}.registration .slider-container .controls .fa{cursor:pointer}.registration .right-block{display:-webkit-box;display:-ms-flexbox;display:flex;background:-webkit-gradient(linear,left bottom,left top,from(#3b60f7),to(#2741b0));background:linear-gradient(0deg,#3b60f7 0,#2741b0 100%)}@media (max-width:1199px){.registration .slider-container .controls{display:none}.registration .right-block{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column}}.registration .right-block .reg-footer{width:500px;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.registration .right-block .reg-footer .footer-title{text-align:center;color:#a3aef5;font-size:12px}.registration .right-block .reg-footer ul{list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0 35px 35px 65px;font-size:10px;font-weight:800}.registration .right-block .reg-footer ul li{margin-top:15px;margin-right:25px;width:75px;line-height:90%;letter-spacing:-.1px}.registration .right-block .reg-footer ul li a{color:#7383f1}.registration .right-block .reg-footer ul li:last-child{font-weight:400;font-size:12px}.registration .right-block .reg-footer ul li:last-child a{color:#a3aef5}.registration .right-block .registration-form{padding:45px 30px 39px;font-family:Geometria,sans-serif;font-weight:400;width:370px;max-width:100%;position:relative}.registration .right-block .registration-form .close-mobile{position:absolute;border:1px solid #c0c5e2;color:#c0c5e2;right:10px;top:10px;width:35px;padding:5px;text-align:center;cursor:pointer;display:none}@media (max-width:420px){.registration .right-block .registration-form .close-mobile{right:60px}}.registration .right-block .registration-form .lz-logo{position:absolute;top:.2px;left:-40px}@media (max-width:1199px){.registration .right-block .reg-footer{display:none}.registration .right-block .registration-form{width:545px;padding:25px 120px 20px}.registration .right-block .registration-form .close-mobile{display:block}.registration .right-block .registration-form .lz-logo{display:none}}.registration .right-block .registration-form .lz-logo img{width:120%}.registration .right-block .registration-form .lz-logo-mobile{display:none;position:absolute}@media (max-width:1199px){.registration .right-block .registration-form .lz-logo-mobile{display:block;top:-25px;left:75px}.registration .right-block .registration-form .mobile-title{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}@media (max-width:758px){.registration .right-block .registration-form{width:450px;max-width:100%;padding:25px 68px 10px}.registration .right-block .registration-form .lz-logo-mobile{top:-25px;left:25px}}.registration .right-block .registration-form .lz-logo-mobile img{width:125px}.registration .right-block .registration-form h1{color:#fff;font-size:36px;font-weight:700;margin-bottom:31px}.registration .right-block .registration-form .signIn-mobile{color:#ffbe26;text-transform:uppercase;text-align:center;font-weight:700;letter-spacing:1px;margin-bottom:15px;margin-top:3px;display:none}.registration .right-block .registration-form .signIn-mobile span{cursor:pointer}.registration .right-block .registration-form .close{position:absolute;border:1px solid #727dc7;color:#727dc7;left:312px;top:20px;width:35px;padding:5px;text-align:center;cursor:pointer}.registration .right-block .registration-form .form-group{position:relative}.registration .right-block .registration-form .form-group .error-field{position:absolute;color:#fff;background-color:#ff564e;font-size:12px;top:25px;width:100%;z-index:0}.registration .right-block .registration-form .form-group .error-field span{display:table;margin:3px;line-height:1}.registration .right-block .registration-form .form-group .qmark{color:#ffbe26;cursor:pointer;position:absolute;top:0;right:0;font-size:23px}.registration .right-block .registration-form .form-group .qmark i{opacity:.5}.registration .right-block .registration-form .form-group .qmark .hint{padding:10px 5px;font-size:12px;background-color:#fff;display:none}.registration .right-block .registration-form .form-group .qmark:hover{color:#3b60f7}.registration .right-block .registration-form .form-group .qmark:hover .hint{z-index:1;display:block}.registration .right-block .registration-form .form-group .qmark:hover .hint p{color:#000}.registration .right-block .registration-form .form-group .qmark:hover i{z-index:2;position:absolute;top:3px;left:289px}@media (max-width:1199px){.registration .right-block .registration-form h1{font-size:24px;margin-bottom:10px}.registration .right-block .registration-form .signIn-mobile{display:block}.registration .right-block .registration-form .close{display:none}.registration .right-block .registration-form .form-group .qmark:hover i{left:285px}}.registration .right-block .registration-form .form-label{width:100%;color:#fff;font-weight:bolder;font-size:14px;opacity:0}.registration .right-block .registration-form .form-group:focus-within label{opacity:0}.registration .right-block .registration-form .input-field{background-color:rgba(0,0,0,0);color:#fff;border:none;border-bottom:1px solid #fff;width:100%;height:30px;z-index:1;margin-bottom:20px}.registration .right-block .registration-form .input-field.ng-invalid.ng-touched{border-bottom:1px solid #ff564e;color:#ff564e}.registration .right-block .registration-form .input-field:focus{border-bottom:1px solid #ffbe26}.registration .right-block .registration-form .input-field::-webkit-input-placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.registration .right-block .registration-form .input-field::-ms-input-placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.registration .right-block .registration-form .input-field::placeholder{font-style:normal;font-weight:400;color:#fff;z-index:-10}.registration .right-block .registration-form .input-field.ng-invalid.ng-touched::-webkit-input-placeholder{color:#ff564e}.registration .right-block .registration-form .input-field.ng-invalid.ng-touched::-ms-input-placeholder{color:#ff564e}.registration .right-block .registration-form .input-field.ng-invalid.ng-touched::placeholder{color:#ff564e}.registration .right-block .registration-form .input-field.ng-invalid.submitted::-webkit-input-placeholder{color:#ff564e}.registration .right-block .registration-form .input-field.ng-invalid.submitted::-ms-input-placeholder{color:#ff564e}.registration .right-block .registration-form .input-field.ng-invalid.submitted::placeholder{color:#ff564e}.registration .right-block .registration-form .input-field:focus::-webkit-input-placeholder{opacity:.5}.registration .right-block .registration-form .input-field:focus::-ms-input-placeholder{opacity:.5}.registration .right-block .registration-form .input-field:focus::placeholder{opacity:.5}.registration .right-block .registration-form button{width:100%;background-color:#ffbe26;color:#303f9f;text-transform:uppercase;padding:15px;border:none;font-size:16px;font-weight:800;margin-bottom:20px;letter-spacing:1px;display:flex;display:-webkit-box;display:-ms-flexbox;justify-content:center;-webkit-box-pack:center;-ms-flex-pack:center;text-align:-webkit-center;text-align:-moz-center;cursor:pointer}.registration .right-block .registration-form button p{width:100%}.registration .right-block .registration-form button.loading{padding:23.5px}.registration .right-block .registration-form .signIn{color:#ffbe26;text-transform:uppercase;text-align:center;font-size:14px;font-weight:700;letter-spacing:1px;margin-bottom:15px}@media (max-width:1199px){.registration .right-block .registration-form button{margin-bottom:15px}.registration .right-block .registration-form .signIn{display:none}.registration .right-block .registration-form .check{margin-top:0}}.registration .right-block .registration-form .signIn span{cursor:pointer}.registration .right-block .registration-form .check{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative}.registration .right-block .registration-form .check .container{display:block;position:relative;padding-left:35px;margin-bottom:12px;cursor:pointer;font-size:12px;font-weight:400;color:#fff;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.registration .right-block .registration-form .check .container input{position:absolute;opacity:0;cursor:pointer;top:-18px;left:-2px;width:30px}.registration .right-block .registration-form .check .container a{color:#ffbe26}.registration .right-block .registration-form .check .container .error-field-confirmData{position:absolute;color:#fff;background-color:#ff564e;font-size:12px;width:100%;z-index:0;top:-37px;right:0}.registration .right-block .registration-form .check .container .error-field-confirmData span{display:table;margin:3px;line-height:1}.registration .right-block .registration-form .check .container .error-field-confirmData .pointer{width:10px;height:10px;position:absolute;left:8px;bottom:-3px;z-index:-1;background-color:#ff564e;display:table;transform:rotate(45deg);-webkit-transform:rotate(45deg)}.registration .right-block .registration-form .check .checkmark{position:absolute;top:0;left:0;height:25px;width:25px;background-color:#eee0;border:1px solid #fff}.registration .right-block .registration-form .check .container:hover input~.checkmark{background-color:#ccc0}.registration .right-block .registration-form .check .container input:checked~.checkmark{background-color:#ffbe26;border:none}.registration .right-block .registration-form .check .checkmark:after{content:"";position:absolute;display:none}.registration .right-block .registration-form .check .container input:checked~.checkmark:after{display:block}.registration .right-block .registration-form .check .container .checkmark:after{left:9px;top:5px;width:8px;height:13px;border:solid #303f9f;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.registration .right-block .registration-form .or{overflow:hidden;text-align:center;color:#b2b9f1;font-size:14px;letter-spacing:1px;font-weight:700;margin-bottom:20px}@media (max-width:1199px){.registration .right-block .registration-form .check .container{font-size:10px;padding-left:35px}.registration .right-block .registration-form .or{margin-bottom:15px}}.registration .right-block .registration-form .or:after,.registration .right-block .registration-form .or:before{background-color:#576ae6;content:"";display:inline-block;height:2px;top:50px;width:50%}.registration .right-block .registration-form .or:before{right:.5em;margin-left:-50%;margin-right:5px}.registration .right-block .registration-form .or:after{left:.5em;margin-right:-50%;margin-left:5px}.registration .right-block .registration-form .social-network_icons{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.registration .right-block .registration-form .social-network_icons .social-network_btn{width:85px;max-width:100%;color:#ffbe26;background-color:#596ceb;text-align:center;padding:20px 0;cursor:pointer;margin:0 20px}.registration .right-block .registration-form .social-network_icons .social-network_btn:hover{background-color:#fff}.registration .right-block .registration-form .social-network_icons .social-network_btn:hover .fa-facebook{color:#3b5998}.registration .right-block .registration-form .social-network_icons .social-network_btn:hover .fa-google-plus{color:#dd4b39}.registration .right-block .registration-form .social-network_icons .social-network_btn:hover .fa-linkedin{color:#0077b5}.registration .reg-footer-mobile{width:545px;display:none}@media (max-width:1199px){.registration .right-block .registration-form .social-network_icons .social-network_btn{background-color:#fff;padding:5px 0}.registration .right-block .registration-form .social-network_icons .social-network_btn .fa-facebook{color:#3b5998}.registration .right-block .registration-form .social-network_icons .social-network_btn .fa-google-plus{color:#dd4b39}.registration .right-block .registration-form .social-network_icons .social-network_btn .fa-linkedin{color:#0077b5}.registration .reg-footer-mobile{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex}}.registration .reg-footer-mobile .footer-title{text-align:center;color:#a3aef5;font-size:12px}.registration .reg-footer-mobile ul{list-style:none;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:0 35px 35px 65px;font-size:10px;font-weight:800}@media (max-width:1199px){.registration .reg-footer-mobile ul{margin:0 35px 20px 65px}}.registration .reg-footer-mobile ul li{margin-top:15px;margin-right:25px;width:75px;line-height:90%;letter-spacing:-.1px}.registration .reg-footer-mobile ul li a{color:#7383f1}@media (max-width:758px){.registration .right-block .registration-form .form-group .qmark:hover i{left:293px}.registration .right-block .registration-form .or,.registration .right-block .registration-form button{margin-bottom:10px}.registration .reg-footer-mobile{width:450px}.registration .reg-footer-mobile ul li:nth-child(6),.registration .reg-footer-mobile ul li:nth-child(7){display:none}.registration .reg-footer-mobile ul li:nth-child(2),.registration .reg-footer-mobile ul li:nth-child(5){text-align:center}}.registration .reg-footer-mobile ul li:last-child{font-weight:400;font-size:12px}.registration .reg-footer-mobile ul li:last-child a{color:#a3aef5}`],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})

export class LzRegNewComponent implements OnInit, AfterContentInit, OnDestroy {

  @ViewChild(InvisibleReCaptchaComponent) captcha: InvisibleReCaptchaComponent;
  private lang: string;

  data: any = {
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    companyName: '',
    activity: ''
  };
  public isShowSlider = true;
  public serverMessage;
  public regForm: FormGroup;
  public cFormGroup: FormGroup;
  EMAIL_REGEXP = /^[a-z0-9._-]+@[a-z0-9._-]+\.[a-z0-9]{2,}$/i;
  PHONE_REGEXP = /^(\+\d{3} \(\d{2}\) \d{3}-\d{2}-\d{2})|(\d{10})|(\+?\d{12})/;
  public product = {
    "category": [
      ""
    ],
    "alias": "",
    "sortOrder": 0,
    "backgroundColor": "",
    "fontColor": "",
    "hoverColor": "",
    "title": "",
    "subTitle": "",
    "description": "",
    "logo": "",
    "logoSmall": "",
    "logoSmall2": "",
    "banner": "",
    "bannerSmall": "",
    "hasTest": '',
    "moreLink": "",
    "buyLink": "",
    "enterLink": "",
    "price": "",
    "priceType": "",
    "oldPrice": "",
    "oldPriceType": "",
    "saleTypes": [{
      "alias": "",
      "name": "",
      "image": ""
    }],
    "presentation": {
      "logo": "",
      "descriptionTop": "",
      "descriptionBottom": "",
      "color": "",
      "video": "",
      "slides": [{
        "src": "",
        "description": ""
      }]
    },
    "visible": true
  };
  public currentActiveImg = this.product.presentation.slides[0];
  public currentActiveImgPosition: number;
  public controlAnimation: string = '0';
  public isAnimate: boolean = false;
  public sliderWidth;
  public documentWidth = 0;
  public isSliderFirstPick = true;
  public lastSwipeElement;
  public captchaString;
  public isDisabled;
  public products = [];
  public mask = ['+', '3', '8', '0', ' ', '(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  private sub0: Subscription;
  private sub1: Subscription;
  private sub2: Subscription;
  private sub3: Subscription;
  private sub4: Subscription;
  private alias;
  videoUrl;
  private config;
  public showEmailErrorMessage = false;
  public showPhoneErrorMessage = false;
  public resolved(captchaResponse: string) {}
  public checked = false;
  public submitted = false;
  public needToDisable = true;
  public id;

  constructor(private language: LzLanguageService,
    private dialogRef: MatDialogRef < LzRegNewComponent > ,
    private http: CustomRequestService,
    private translate: TranslateService,
    private dialog: MatDialog,
    public sanitizer: DomSanitizer,
    private lzCookie: LzCookieService,
    private lzProductConfig: LzProductConfig,
    @Inject(MAT_DIALOG_DATA) public presentantionData: any,
    @Inject(DOCUMENT) private document: any) {

    this.lang = this.language.identifyLanguage();
    this.config = lzProductConfig.getProductSettings();
    this.getProductsForFooter();
    this.alias = this.presentantionData.alias || this.config['order_code'];
    this.id = this.config['order_code'] || 'platforma';
    this.captchaString = presentantionData.captchaString;
    this.isShowSlider = (this.config['isShowSlidersOnRegAndTestFroms'] === 'show') ? true : false;
  }

  ngAfterContentInit() {

    this.getProductPresentation(this.alias);

  }

  ngOnInit() {
    this.regForm = new FormGroup({
      'firstname': new FormControl(null, [Validators.required]),
      'lastname': new FormControl(null, [Validators.required]),
      'email': new FormControl(null, [Validators.required, Validators.pattern(this.EMAIL_REGEXP)]),
      'phone': new FormControl(null, [Validators.required, Validators.pattern(this.PHONE_REGEXP)]),
      'company': new FormControl(null, [Validators.required]),
      'confirmDataSaving': new FormControl(null, [Validators.requiredTrue])
    });
    this.cFormGroup = new FormGroup({
      'recaptcha': new FormControl(null, [Validators.required])
    });
    this.watchErrorRequired();
  }

  cancel() {
    this.dialogRef.close();
  };

  getToken(service) {
    location.href = service;
  }
  toggleCheckbox() {
    this.checked = !this.checked;
  }
  getProductPresentation(alias: string) {
    let video;
    this.sub1 = this.http.getRequest(this.lzProductConfig.getApiLink() + "/lz-platforma/product/v1.0/info/" + alias)
      .subscribe((msg) => {
        this.product = msg;
        video = this.product.presentation.video.replace('watch?v=', 'embed/')
        this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(video);
        setTimeout(this.setActiveSpecified(this.product.presentation.slides[0]), 0);
      })
  }

  getProductsForFooter() {
    this.sub4 = this.http.getRequest(this.lzProductConfig.getApiLink() + "/lz-platforma/product/v1.0/all")
      .subscribe((msg) => {
        this.products = this.sortByOrder(msg, 'sortOrder').slice(0, 7);
        for (let i: number = 0; i < this.products.length; i++) {
          this.products[i].title = this.products[i].title.replace('&', ' &');
        }

      })
  }


  execute() {

    console.log("CAPTCHA EXECUTE");

    this.isDisabled = true;
    this.submitted = true;

    if (this.regForm.invalid) {
      this.isDisabled = false;
      return;
    } else {

      this.captcha.execute();
      setTimeout(() => {
        if (this.needToDisable == true) {
          this.isDisabled = false
        }

      }, 5000);
    }
  }

  reg(captchaResponse: string) {

    console.log("REG");

    this.needToDisable = false;
    this.isDisabled = true;

    let siteSource = '';
    if (!!(this.lzCookie.getCookie('referer'))) {
      siteSource = decodeURIComponent(this.lzCookie.getCookie('referer'));
    } else {
      siteSource = window.location.href;
      if (siteSource.indexOf('?') != -1) {
        siteSource = siteSource.split('?')[0];
      }
    }

    let par = {
      email: this.data.email ? this.data.email : '',
      firstName: this.data.name ? this.data.name : '',
      lastName: this.data.lastname ? this.data.lastname : '',
      phone: this.data.phone ? this.data.phone.replace(/[^0-9+]/g, "") : '',
      companyName: this.data.company ? this.data.company : '',
      activity: this.data.activity ? this.data.activity : '',
      product_code: "ipas_commercial",
      utm_source: this.lzCookie.getCookie('utm_sourceHistory') || '',
      utm_medium: this.lzCookie.getCookie('utm_mediumHistory') || '',
      utm_campaign: this.lzCookie.getCookie('utm_campaignHistory') || '',
      dealerId: this.lzCookie.getCookie('dealerIdHistory') || '',
      partnerCode: this.lzCookie.getCookie('partnerCodeHistory') || '',
      'g-recaptcha-response': captchaResponse,
      "language": this.lang,
      'site_source': siteSource
    };


    this.sub0 = this.http.postRequestWithFormData(this.lzProductConfig.getApiLink() + '/lz-platforma/auth/v2.0/registration', par, {}, {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      })
      .subscribe((msg) => {

          console.log("REG SUBSCRIPTION");

          if (!msg.isOk == true) {
            
            console.log("CAPTCHA RESET");
            this.captcha.resetCaptcha();

            try {
              grecaptcha.reset();
            } catch(e) { }
            
            this.isDisabled = false;
            this.serverMessage = msg.message;
            if (this.serverMessage.hasOwnProperty('email')) {
              this.showEmailErrorMessage = true;
              this.isDisabled = false
            }
            if (this.serverMessage.hasOwnProperty('phone')) {
              this.showPhoneErrorMessage = true;
              this.isDisabled = false
            }
          } else {
            if (!window['dataLayer']) {
              window['dataLayer'] = [];
            }
            window['dataLayer'].push({
              'event': 'autoEvent',
              'eventCategory': 'register',
              'eventAction': this.id,
              'eventLabel': this.lzCookie.getCookie('referer') ? decodeURIComponent(this.lzCookie.getCookie('referer')) : window.location.href
            });
            this.dialogRef.close();
            this.presentantionData.showWelc(this.data.email, 'regForm');
          }
        },
        (error) => {
          this.captcha.resetCaptcha();
          try {
            grecaptcha.reset();
          } catch(e) { }
          this.isDisabled = false;
        });


    setTimeout(() => {
      this.showEmailErrorMessage = false;
      this.showPhoneErrorMessage = false;
    }, 10000)

  }

  public showAuthModal() {
    let alias = '';
    if (this.presentantionData && this.presentantionData.alias) {
      alias = this.presentantionData.alias;
    }
    this.dialogRef.close();
    this.presentantionData.showAuth(false, alias);
  }


  onResize(event) {
    let width = $(document).width();
    if (!this.checkSliderWidth(this.documentWidth, width)) {
      this.isSliderFirstPick = true;
      this.documentWidth = width;
      this.setActiveSpecified(this.currentActiveImg);
    }
  }

  private checkSliderWidth = (lastWidth, currentWidth): boolean => {
    if (lastWidth >= 1490 && currentWidth >= 1490 ||
      lastWidth >= 1002 && currentWidth >= 1002 && lastWidth < 1490 && currentWidth < 1490 ||
      lastWidth >= 758 && currentWidth >= 758 && lastWidth < 1002 && currentWidth < 1002 ||
      lastWidth >= 480 && currentWidth >= 480 && lastWidth < 758 && currentWidth < 758 ||
      lastWidth >= 0 && currentWidth >= 0 && lastWidth < 480 && currentWidth < 480) {
      return true;
    }
    return false;
  }

  //default count == 1
  public setActiveNext = (count ? ) => {
    let cnt = count || 1;
    this.isAnimate = true;

    if (this.documentWidth <= 480) {
      this.controlAnimation = (-100 * cnt) + '%';
    }
    if (this.documentWidth <= 758) {
      this.controlAnimation = (-50 * cnt) + '%';
    }

    this.currentActiveImg = this.product.presentation.slides[this.currentActiveImgPosition + cnt];

    setTimeout(() => {
      setTimeout(() => {
        this.isAnimate = false;
        this.controlAnimation = '0';
        this.product.presentation.slides = this.product.presentation.slides.splice(cnt, this.product.presentation.slides.length - 1)
          .concat(this.product.presentation.slides.splice(0, cnt));
        this.swipedetect(this.lastSwipeElement, $("#swipe.active"));
      }, 0);
    }, 0);
  }

  //default count == 1
  public setActivePrev = (count ? ) => {
    let cnt = count || 1;
    let product = this.product.presentation.slides[this.currentActiveImgPosition - cnt];
    this.isAnimate = true;

    this.product.presentation.slides = this.product.presentation.slides.splice(this.product.presentation.slides.length - cnt, this.product.presentation.slides.length)
      .concat(this.product.presentation.slides.splice(0, this.product.presentation.slides.length));

    if (this.documentWidth <= 480) {
      this.controlAnimation = (-100 * cnt) + '%';
    }
    if (this.documentWidth <= 758) {
      this.controlAnimation = (-50 * cnt) + '%';
    }

    setTimeout(() => {
      this.controlAnimation = '0';
      this.isAnimate = true;
      if (product) {
        this.currentActiveImg = product;
      } else {
        this.currentActiveImg = this.product.presentation.slides[0];
      }

      setTimeout(() => {
        this.isAnimate = false;
        this.swipedetect(this.lastSwipeElement, $("#swipe.active"));
      }, 500);
    }, 0);
  }


  private setActiveSpecified = (img) => {
    if (!this.isSliderFirstPick) {
      if (img == this.currentActiveImg) {
        return;
      }
      if (this.product.presentation.slides.indexOf(img) - this.currentActiveImgPosition >= 1) {
        this.setActiveNext(this.product.presentation.slides.indexOf(img) - this.currentActiveImgPosition);
        return;
      }
      if (this.product.presentation.slides.indexOf(img) - this.currentActiveImgPosition <= -1) {
        this.setActivePrev((this.product.presentation.slides.indexOf(img) - this.currentActiveImgPosition) * -1);
        return;
      }
    }
    let position = 0;

    let elementsCount = position - this.product.presentation.slides.indexOf(img);

    if (elementsCount < 0) {
      elementsCount *= -1;
      this.product.presentation.slides = this.product.presentation.slides.slice(elementsCount, this.product.presentation.slides.length)
        .concat(this.product.presentation.slides.slice(0, elementsCount));
    } else {
      this.product.presentation.slides = this.product.presentation.slides.slice(this.product.presentation.slides.length - elementsCount, this.product.presentation.slides.length)
        .concat(this.product.presentation.slides.slice(0, this.product.presentation.slides.length - elementsCount));
    }

    this.isSliderFirstPick = false;
    this.currentActiveImgPosition = position;
    this.currentActiveImg = img;

    setTimeout(() => {
      this.swipedetect(this.lastSwipeElement, $("#swipe.active"));
    }, 0);
  }

  private swipedetect = (lastEl, el, callback ? ) => {
    if (this.product.presentation.slides.length == 1) {
      return;
    }
    try {
      lastEl.off();
    } catch (e) {

    } finally {
      this.lastSwipeElement = el;
      let touchsurface = el,
        swipedir,
        startX,
        startY,
        distX,
        distY,
        threshold = 100, //required min distance traveled to be considered swipe
        restraint = 100, // maximum distance allowed at the same time in perpendicular direction
        allowedTime = 300, // maximum time allowed to travel that distance
        elapsedTime,
        startTime,
        handleswipe = callback || function (swipedir) {
          if (swipedir == 'right') {
            this.setActivePrev();
          }
          if (swipedir == 'left') {
            this.setActiveNext();
          }
        }.bind(this);

      touchsurface.on({
        'touchstart': function (e) {
          var touchobj = e.changedTouches[0];
          swipedir = 'none';
          distX = 0;
          distY = 0;
          startX = touchobj.pageX;
          startY = touchobj.pageY;
          startTime = new Date().getTime(); // record time when finger first makes contact with surface
          // e.preventDefault();
        }
      }, false);

      touchsurface.on({
        'touchmove': function (e) {
          // e.preventDefault() // prevent scrolling when inside DIV
        }
      }, false);

      touchsurface.on({
        'touchend': function (e) {
          var touchobj = e.changedTouches[0];
          distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
          distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
          elapsedTime = new Date().getTime() - startTime; // get time elapsed
          if (elapsedTime <= allowedTime) { // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) { // 2nd condition for horizontal swipe met
              swipedir = (distX < 0) ? 'left' : 'right'; // if dist traveled is negative, it indicates left swipe
              e.preventDefault();
            } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) { // 2nd condition for vertical swipe met
              swipedir = (distY < 0) ? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
            }
          }
          handleswipe(swipedir);
          e.preventDefault();
        }
      }, false);
    }
  }

  watchErrorRequired() {
    let values: Observable < number > = interval(100);
    let fnRequired: string;
    let lnRequired: string;
    let emailRequired: string;
    let phoneRequired: string;
    let companyRequired: string;
    let cptchwrppr: any;
    let cptch: any;
    let body: any = document.body;

    this.translate.get('lzPurchase.firstNameRequired').subscribe(trans => fnRequired = trans);
    this.translate.get('lzPurchase.enterLastnameRequired').subscribe(trans => lnRequired = trans);
    this.translate.get('lzPurchase.emailRequired').subscribe(trans => emailRequired = trans);
    this.translate.get('lzPurchase.phoneRequired').subscribe(trans => phoneRequired = trans);
    this.translate.get('lzPurchase.companyNameRequired').subscribe(trans => companyRequired = trans);

    this.sub2 = values.subscribe(() => {
      if ((this.regForm.get('firstname').invalid && this.regForm.get('firstname').touched &&
          this.regForm.get('firstname')['errors']['required']) || (this.regForm.get('firstname').invalid && this.submitted &&
          this.regForm.get('firstname')['errors']['required'])) {
        $('#firstname').attr('placeholder', fnRequired);
      }
      if ((this.regForm.get('lastname').invalid && this.regForm.get('lastname').touched &&
          this.regForm.get('lastname')['errors']['required']) || (this.regForm.get('lastname').invalid && this.submitted &&
          this.regForm.get('lastname')['errors']['required'])) {
        $('#lastname').attr('placeholder', lnRequired);
      }
      if ((this.regForm.get('email').invalid && this.regForm.get('email').touched &&
          this.regForm.get('email')['errors']['required']) || (this.regForm.get('email').invalid && this.submitted &&
          this.regForm.get('email')['errors']['required'])) {
        $('#e-mail').attr('placeholder', emailRequired);
      }
      if ((this.regForm.get('phone').invalid && this.regForm.get('phone').touched &&
          this.regForm.get('phone')['errors']['required']) || (this.regForm.get('phone').invalid && this.submitted &&
          this.regForm.get('phone')['errors']['required'])) {
        $('#phone').attr('placeholder', phoneRequired);
      }
      if ((this.regForm.get('company').invalid && this.regForm.get('company').touched &&
          this.regForm.get('company')['errors']['required']) || (this.regForm.get('company').invalid && this.submitted &&
          this.regForm.get('company')['errors']['required'])) {
        $('#company').attr('placeholder', companyRequired);
      }

      if (this.submitted && !this.regForm.invalid) {

        if (cptchwrppr != $(body).children('div')[$(body).children('div').length - 1]) {
          cptchwrppr = $(body).children('div')[$(body).children('div').length - 1];
        }
        cptch = $(cptchwrppr).children('div')[1];
        $(cptch).css('position', 'fixed');
        this.submitted = false;
      }

    });


    this.sub3 = this.regForm.valueChanges.subscribe(() => {
      this.showEmailErrorMessage = false;
      this.showPhoneErrorMessage = false;

      for (let key in this.serverMessage) {

        this.serverMessage[key] = '';


      }
    })
  }
  sortByOrder(array: any, key: string) {
    let result = array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });

    return result;
  }

  ngOnDestroy() {
    if (this.sub0) {
      this.sub0.unsubscribe();
    }
    if (this.sub1) {
      this.sub1.unsubscribe();
    }
    if (this.sub2) {
      this.sub2.unsubscribe();
    }
    if (this.sub3) {
      this.sub3.unsubscribe();
    }
    if (this.sub4) {
      this.sub4.unsubscribe();
    }
  }
}
